import React, { useState, useEffect } from "react";
import Navbar from "../components/helpers/Navbar";
import Footer from "../components/helpers/Footer";
import { Form, Button, Row, Col, Spinner } from "react-bootstrap"; // Am adăugat Spinner pentru feedback vizual
import { newsletterTemplates } from "../assets/templates/newsletterTemplates";


const TrimiteNewsletter = () => {
  const [recipients, setRecipients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedRecipientIds, setSelectedRecipientIds] = useState([]);
  const [selectedTemplateId, setSelectedTemplateId] = useState(
    newsletterTemplates[0].id
  );
  const [preview, setPreview] = useState("");
  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const fetchAllRecipients = async () => {
      setLoading(true);
      try {
        const headers = { Authorization: "Bearer unwantedtok" };
        const apiUrl = "https://prdp-api.suport-949.workers.dev/api";

        const [membersRes, volunteersRes] = await Promise.all([
          fetch(`${apiUrl}/membri`, { headers }),
          fetch(`${apiUrl}/voluntari`, { headers }),
        ]);

        const membersData = await membersRes.json();
        const volunteersData = await volunteersRes.json();

        const combinedList = [...membersData, ...volunteersData];

        const uniqueRecipients = Array.from(
          new Map(combinedList.map((person) => [person.email, person])).values()
        );

        uniqueRecipients.sort((a, b) => a.nume.localeCompare(b.nume));

        setRecipients(uniqueRecipients);
      } catch (error) {
        console.error("Eroare la preluarea destinatarilor:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllRecipients();
  }, []);

  useEffect(() => {
    const template = newsletterTemplates.find(
      (t) => t.id === selectedTemplateId
    );
    const firstRecipient =
      recipients.find((r) => selectedRecipientIds.includes(r.id)) || recipients[0];
    if (template && firstRecipient) {
      setPreview(template.getContent(firstRecipient));
    } else {
      setPreview("");
    }
  }, [selectedTemplateId, selectedRecipientIds, recipients]);

  const toggleRecipient = (id) => {
    setSelectedRecipientIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleSend = async () => {
    if (selectedRecipientIds.length === 0) return;

    setSending(true);
    setSuccess(null);

    const template = newsletterTemplates.find(
      (t) => t.id === selectedTemplateId
    );
    const selectedPersons = recipients.filter((r) =>
      selectedRecipientIds.includes(r.id)
    );

    try {
      for (const person of selectedPersons) {
        await fetch(
          "https://prdp-api.suport-949.workers.dev/api/trimite-mail",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer secrettoken",
            },
            body: JSON.stringify({
              to: person.email,
              name: `${person.prenume} ${person.nume}`,
              subject: template.subject,
              htmlContent: template.getContent(person),
            }),
          }
        );
      }
      setSuccess(true);
    } catch (err) {
      setSuccess(false);
    } finally {
      setSending(false);
    }
  };

  // Filter recipients by search term (case-insensitive by name and email)
  const filteredRecipients = recipients.filter((r) => {
    const term = searchTerm.toLowerCase();
    return (
      r.nume.toLowerCase().includes(term) ||
      r.prenume.toLowerCase().includes(term) ||
      r.email.toLowerCase().includes(term)
    );
  });

  return (
    <>
      <Navbar />
      <div className="container py-5">
        <h2 className="text-center mb-4 text-primary-dark fw-bold">
          Trimite Newsletter PRDP
        </h2>

        <Row className="mb-4">
          <Col md={12}>
            <Form.Group className="mb-3">
              <Form.Label>
                <strong>Caută membri după nume sau email</strong>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Introdu nume sau email..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={12}>
            <Form.Group className="mb-4">
              <Form.Label>
                <strong>Selectează template</strong>
              </Form.Label>
              <Form.Select
                value={selectedTemplateId}
                onChange={(e) => setSelectedTemplateId(e.target.value)}
              >
                {newsletterTemplates.map((tpl) => (
                  <option key={tpl.id} value={tpl.id}>
                    {tpl.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={12}>
            <Form.Group>
              <Form.Label>
                <strong>
                  Selectează destinatarii ({filteredRecipients.length} filtrați)
                </strong>
              </Form.Label>
              <div
                style={{
                  maxHeight: "300px",
                  overflowY: "auto",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  padding: "1rem",
                }}
              >
                {loading ? (
                  <div className="text-center">
                    <Spinner animation="border" variant="primary" />
                    <p>Se încarcă lista...</p>
                  </div>
                ) : filteredRecipients.length === 0 ? (
                  <p>Nu s-au găsit membri cu această căutare.</p>
                ) : (
                  filteredRecipients.map((r) => (
                    <Form.Check
                      key={r.id}
                      type="checkbox"
                      label={`${r.prenume} ${r.nume} (${r.email})`}
                      checked={selectedRecipientIds.includes(r.id)}
                      onChange={() => toggleRecipient(r.id)}
                    />
                  ))
                )}
              </div>
              <Button
                className="mt-2"
                variant="outline-secondary"
                size="sm"
                onClick={() => setSelectedRecipientIds(filteredRecipients.map((r) => r.id))}
              >
                Selectează toți vizibili
              </Button>
              <Button
                className="mt-2 ms-2"
                variant="outline-secondary"
                size="sm"
                onClick={() => setSelectedRecipientIds([])}
              >
                Deselectează toți
              </Button>
            </Form.Group>
          </Col>
        </Row>

        <Form.Group className="mb-4">
          <Form.Label>
            <strong>Previzualizare email</strong>
          </Form.Label>
          <div
            className="preview-newsletter"
            style={{
              border: "1px solid #eee",
              padding: "24px",
              borderRadius: "12px",
              background: "#fff",
            }}
            dangerouslySetInnerHTML={{ __html: preview }}
          />
        </Form.Group>

        <div className="text-center">
          <Button
            variant="primary"
            size="lg"
            onClick={handleSend}
            disabled={sending || selectedRecipientIds.length === 0}
          >
            {sending
              ? "Se trimit emailurile..."
              : `Trimite newsletter-ul către ${selectedRecipientIds.length} destinatari`}
          </Button>
          {success === true && (
            <div className="text-success mt-3">
              Newsletter trimis cu succes către {selectedRecipientIds.length} destinatari.
            </div>
          )}
          {success === false && (
            <div className="text-danger mt-3">Eroare la trimiterea newsletter-ului.</div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TrimiteNewsletter;
